export const ENTITY = 'USEFUL';

export enum TYPE {
   RESOURCE = 'RESOURCE',
   ABOUT_PORTAL ='ABOUT_PORTAL'
}